import { AcceptedFileTypes, buildFileUploadDescription } from "src/utils/files";

// AGNT-959: Define supported file formats and size limits per model provider.
// Not all file types below work with every model provider.
// See: https://linear.app/taktile/issue/AGNT-959/define-supported-agent-file-formats-and-size-limits-per-model
export const PLAYGROUND_ACCEPTED_FILE_TYPES: AcceptedFileTypes = {
  "text/plain": [".txt"],
  "application/pdf": [".pdf"],
  "image/png": [".png"],
  "image/jpeg": [".jpg", ".jpeg"],
  "image/webp": [".webp"],
  "text/csv": [".csv"],
  "application/json": [".json"],
  "text/html": [".html"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
    ".xlsx",
  ],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
  "application/msword": [".doc"],
  "video/mp4": [".mp4"],
};

export const PLAYGROUND_MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024; // 10MB

export const PLAYGROUND_FILE_UPLOAD_DESCRIPTION = buildFileUploadDescription(
  PLAYGROUND_ACCEPTED_FILE_TYPES,
  PLAYGROUND_MAX_FILE_SIZE_BYTES,
);
